import type { EChartsExtensionInstallRegisters, ExtensionAPI } from 'echarts';
import { prepareFlagInfoList, shiftLayoutOnY } from './FlagLayoutHelper';

function adjustFlagPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'flag');
  dvMarkerModel.forEach(markModel => {
    const markView = chart.getViewOfSeriesModel(markModel);
    const gridRect = markModel.coordinateSystem.master.getRect();
    const flagInfoList = prepareFlagInfoList(markView);
    shiftLayoutOnY(flagInfoList, gridRect.y, gridRect.y + gridRect.height);
  });
}

export function dvMarkerExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (_, chart) => {
    // todo目前为flag标记特有的位置调整扩展
    adjustFlagPosition(chart);
  });
}
